// setupRuntime.ts
import type { App } from 'vue';

import CertifidV2UILib from 'certifid-v2-uilib-vue3';
import 'certifid-v2-client-hub-shared/dist/certifid-v2-client-hub-shared.css';
import 'certifid-v2-uilib-vue3/dist/certifid-v2-uilib-vue3.css';
import 'certifid-v2-client-hub-styles/overrides/uilib-overrides.css';
import 'certifid-v2-client-hub-styles/uilib-theme-bridge.css';

import { initAxios, initAuthAxios } from "@Api/axiosClient";
import { setSharedAxiosInstance } from '@Shared';

export function setupRuntime(app: App) {
    app.use(CertifidV2UILib);
    const instance = initAxios(import.meta.env.VITE_API_BASE_URL);
    const authInstance = initAuthAxios(import.meta.env.VITE_AUTH_BASE_URL);
    setSharedAxiosInstance(instance);

}
